import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=d6d871d0&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "instruction.vue"
export default component.exports